<template>
	<!-- header -->
	<header id="header">
		<div class="hInner header_charge_publish subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="#"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">청구서 발행</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>

	<section id="charge_publish">
		<div class="content content_w charge_publish">
			<div class="contIn">
				<form ref="form_publish_create" id="form_publish_create"
					:action="`${SERVER_URL}/api/app/aiorder/charge_publish`"
					@submit.prevent="form_publish_create_submit()" method="post" autocomplete="off">
					<table>
						<thead>
							<tr>
								<th class="cols1">접수번호</th>
								<th class="cols2">주문일<br>출고 완료일</th>
								<th class="cols3">환자명</th>
								<th class="cols4">병원</th>
								<th class="cols5">치식</th>
								<th class="cols6">보철물</th>
								<th class="cols7">수량</th>
								<th class="cols8">단가</th>
								<th class="cols9">합계금액</th>
								<th class="cols10">기공의뢰서</th>
							</tr>
						</thead>
						<tbody>
							<template v-if="items.length > 0" v-for="(item, index) in items" :key="index">
								<tr v-for="(price, idx) in item.priceData" :key="idx">
									<input v-if="index === 0 && idx === 0" type="hidden" name="hos_id"
										:value="item.hospital_mb_id">
									<input type="hidden" name="aiorder_id[]" :value="item.id">
									<input type="hidden" name="aiorder_no[]" :value="item.aiorder_no">
									<input type="hidden" name="patientName[]" :value="orderJsonData[index].patientName">
									<input type="hidden" name="hospitalName[]"
										:value="orderJsonData[index].hospitalName">
									<input type="hidden" name="labName[]" :value="orderJsonData[index].labName">
									<input type="hidden" name="teeths[]" :value="orderJsonData[index][`teeth_${idx + 1}`][0].replaceAll(',', '/')">
									<input type="hidden" name="options[]"
										:value="orderJsonData[index][`options_${idx + 1}`]">
									<input type="hidden" name="detail[]"
										:value="orderJsonData[index][`detail_${idx + 1}`]">
									<input type="hidden" name="price[]" :value="price_value(price)">
									<input type="hidden" name="price_sum[]"
										:value="price_value(price) * orderJsonData[index][`teeth_${idx + 1}`][0].split(',').length">

									<td class="cols1">{{ item.aiorder_no }}</td>
									<td class="cols2">{{ commonjs.dateFormatYMD(orderJsonData[index].registerDate) }}<br />{{ commonjs.dateFormatYMD(item.order_complete_datetime) }}</td>
									<td class="cols3">{{ orderJsonData[index].patientName }}</td>
									<td class="cols4">{{ orderJsonData[index].hospitalName }}</td>
									<td class="cols5">{{ orderJsonData[index][`teeth_${idx + 1}`][0].replaceAll(',', '/') }}</td>
									<td class="cols6">{{ orderJsonData[index][`options_${idx + 1}`] }}<br />{{ orderJsonData[index][`detail_${idx + 1}`] }}</td>
									<td class="cols7">{{ orderJsonData[index][`teeth_${idx + 1}`][0].split(',').length
										}}
									</td>
									<td class="cols8">{{ price_value(price).toLocaleString() }}</td>
									<td class="cols9">{{ (price_value(price) * orderJsonData[index][`teeth_${idx + 1}`][0].split(',').length).toLocaleString()
										}}</td>
									<td class="cols10">
										<div class="icon_aiFile"
											@click="commonjs.pagePopup(`/aiorder_view/${item.id}`)"></div>
									</td>
								</tr>
							</template>
							<tr v-else>
								<td colspan="10">데이터가 없습니다.</td>
							</tr>
						</tbody>
					</table>

					<table class="chargeTable">
						<tbody>
							<tr>
								<!-- 매달 1일 -->
								<td class="chargeCols1"><label for="bill_start_date">청구 시작일</label></td>
								<td class="chargeCols2"><input type="date" name="bill_start_date" id="bill_start_date" v-model="bill_start_date" required="" @change="setDateRange('bill_start_date', 'bill_end_date')" :max="endDay"></td>
							</tr>
							<tr>
								<!-- 매달 말일 -->
								<td class="chargeCols1"><label for="bill_end_date">청구 종료일</label></td>
								<td class="chargeCols2"><input type="date" name="bill_end_date" id="bill_end_date" v-model="bill_end_date" required="" @change="setDateRange('bill_start_date', 'bill_end_date')" :min="firstDay"></td>
							</tr>
							<tr>
								<td class="chargeCols1">기공 합계 금액</td>
								<td class="chargeCols2">{{ sum_price.toLocaleString() }} 원</td>
							</tr>
							<tr>
								<td class="chargeCols1">가격 조정 금액</td>
								<td class="chargeCols2"><span class="hypen">-</span>
									<input type="text" data-type="number" id="chargeAdjust" v-model="chargeAdjust" placeholder="" required="" @keyup.enter.prevent="form_publish_create_submit()" @input="handleMaxLengthCheck" @blur="handleValueCheck"> 원
								</td>
							</tr>
							<tr class="total">
								<td class="chargeCols1">최종 합계 금액</td>
								<td class="chargeCols2"><span id="total_price">{{ Number(total_price).toLocaleString() }}</span>원</td>
							</tr>
						</tbody>
					</table>

					<button type="button" class="btn_style1 publishBtn" style="display:block;" @click="form_publish_create_submit()">발행</button>
				</form>
			</div>
		</div>
	</section>
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const route = useRoute();
const router = useRouter();

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

const today = moment().format('YYYY-MM-DD');
const firstDay = moment().startOf('month').format('YYYY-MM-DD');
const endDay = moment().endOf('month').format('YYYY-MM-DD');

const props = defineProps({
	// 240819 여러 주문을 선택할수 있기 때문에 String으로 변경, 복수형으로 ids로 변경.
	ids: {
		type: String,
		required: true
	},
});

const aiorder_ids = ref(props.ids);

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const goto_url = (url) => {
	router.push(url);
}

const price_value = (obj) => {
//console.debug(obj.den_price, obj.hos_price);
//console.debug(Number(obj.den_price), Number(obj.hos_price));
	return (obj.hos_price == null) ? Number(obj.den_price) : Number(obj.hos_price);
}

// 241101 조정금액 입력시 날짜 변경되지 않도록 v-model로 수정
const bill_start_date = ref(firstDay);
const bill_end_date = ref(endDay);
const chargeAdjust = ref(0);

const sum_price = ref(0);


let total_price = computed(() => {
	return sum_price.value - Number(chargeAdjust.value);
});

// 이벤트 핸들러 함수 정의
function handleMaxLengthCheck(event) {
	maxLengthCheck(event, chargeAdjust);
}

function handleValueCheck(event) {
	valueCheck(event, chargeAdjust);
}

// `maxLengthCheck` 함수 정의
function maxLengthCheck(event, dataObjectRef) {
	const object = event.target;

	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// 나머지 함수 로직...
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 숫자만 허용하는 경우, 숫자가 아닌 문자 제거
	if (object.dataset.type === 'number') {
		object.value = object.value.replace(/\D/g, '');
	}

	// maxLength 제한이 있는 경우, 입력 길이를 제한
	if (object.dataset.maxLength) {
		if (object.value.length > object.dataset.maxLength) {
			object.value = object.value.slice(0, object.dataset.maxLength);
		}
	}

	// Vue 데이터 모델 업데이트
	try {
		dataObjectRef.value = object.value;
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

function valueCheck(event, dataObjectRef) {
	const object = event.target;

	// 디버깅: 전달된 객체가 무엇인지 콘솔에 출력
	console.log('Received dataObjectRef:', dataObjectRef);

	// `dataObjectRef.value`가 유효한지 확인
	if (typeof dataObjectRef.value === 'undefined') {
		console.debug('Invalid data object reference provided.');
		return;
	}

	// `id` 속성을 사용하여 데이터 모델 속성 이름을 추론
	const modelName = object.id;
	if (!modelName) {
		console.debug('Input element does not have an id attribute.');
		return;
	}

	// 입력 값이 비어 있는 경우 0으로 설정
	let newValue = object.value.trim();
	if (newValue.length < 1) {
		newValue = '0';
	} else {
		// 숫자 변환: 앞의 불필요한 0을 제거
		newValue = parseInt(newValue, 10).toString();
	}

	// DOM 업데이트
	object.value = newValue;

	// Vue 데이터 모델 업데이트
	dataObjectRef.value = newValue;
	try {
		dataObjectRef.value = newValue;
		console.log(`Updated ${modelName} in data object:`, dataObjectRef.value);
	} catch (error) {
		console.error('Error updating data model:', error);
	}
}

const calculateSumPrice = () => {
	let total = 0;
	items.value.forEach((item, index) => {
		item.priceData.forEach((price, idx) => {
			total += price_value(price) * orderJsonData.value[index][`teeth_${idx + 1}`][0].split(',').length;
		});
	});
	sum_price.value = total;
};

const setDateRange = (minObj, maxObj) => {
	document.getElementById(maxObj).min = document.getElementById(minObj).value;
	document.getElementById(minObj).max = document.getElementById(maxObj).value;
}

onMounted(async () => {
	await getModels();
	document.getElementById('bill_start_date').value = firstDay; // 
});

const items = ref([]);
const orderJsonData = ref([]);

const getModels = async () => {
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('aiorder_ids', aiorder_ids.value);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/aiorder/charge_publish`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
		for (let i = 0; i < items.value.length; i++) {
			//orderJsonData.value[items.value[i].id] = (JSON.parse(items.value[i].order_json_data));
			// 241022 파싱할때 특수문자 오류. sanitizeJSONString함수 추가.
			const sanitizedData = commonjs.sanitizeJSONString(items.value[i].order_json_data);
			orderJsonData.value.push(JSON.parse(sanitizedData));
		}
console.log(orderJsonData.value);
		calculateSumPrice();
	} catch (error) {
console.error('Error getModels:', error);
	}
}

async function form_publish_create_submit() {
	await withSubmitFlag(async () => {
		const formElement = document.getElementById('form_publish_create');
		const essentials = formElement.querySelectorAll('[required]');
		for (const element of essentials) {
			if (!element.value || element.value.trim() === '' || element.value.trim().length < 1) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`필수 입력`, `[${fieldName}]은 필수 입력 항목입니다.`, `#${element.id}`, 'self');
				return false;
			}

			// input type="date"의 경우 날짜 형식 검증
			if (element.type === 'date' && !commonjs.isValidDate(element.value)) {
				const label = formElement.querySelector(`label[for="${element.id}"]`);
				const fieldName = label ? label.textContent.replace(':', '') : element.name;
				commonjs.formSwal(`날짜 형식 오류`, `[${fieldName}]의 날짜 형식이 올바르지 않습니다.`, `#${element.id}`, 'self');
				return false;
			}
		}

		const params = new URLSearchParams();
		params.append('acc_type', globaljs.acc_type);
		params.append('mb_id', globaljs.mb_id);
		params.append('mb_boss_id', globaljs.mb_boss_id);
		// hos_id는 hidden으로 넘어감.
		params.append('chargeAdjust', chargeAdjust.value);
		params.append('total_price', total_price.value);

		formElement.querySelectorAll('input').forEach((input) => {
			if (input.type === 'checkbox' && input.id !== 'chk_all' && input.name !== "") {
				if (input.checked) {
					if (!params.has(input.name)) {
						params.append(input.name, input.value);
					} else {
						const existingValue = params.get(input.name);
						params.set(input.name, `${existingValue},${input.value}`);
					}
				}
			} else if (input.type === 'radio' && input.name !== "") {
				if (input.checked) {
					params.append(input.name, input.value);
				}
			} else if (input.name) { // input.name이 존재하는 경우에만 추가
				params.append(input.name, input.value);
			}
		});

		formElement.querySelectorAll('select').forEach((select) => {
			if (select.name) { // select.name이 존재하는 경우에만 추가
				params.append(select.name, select.value);
			}
		});

		formElement.querySelectorAll('textarea').forEach((textarea) => {
			if (textarea.name) { // textarea.name이 존재하는 경우에만 추가
				params.append(textarea.name, textarea.value);
			}
		});

		const is_confirm = await commonjs.confirmSwal('청구서 발행 확인', '입력하신 내용으로 청구서를 발행하시겠습니까?');
		if (!is_confirm) {
			return false;
		}

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/aiorder/charge_publish`, params)
	console.debug(response.data.result);
			commonjs.formSwal('발행 완료', '청구서를 발행했습니다.', 'popup');
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>